import { assetUrl } from "../api/client.js";

/**
 * Curated stock-photo fallbacks for when the admin hasn't uploaded an image
 * yet. Pools are deliberately large so adjacent cards on the same page
 * rarely repeat. Every URL was HEAD-checked at authoring time.
 *
 * Free under the Unsplash License.
 */

const params = "auto=format&fit=crop&q=80";
const u = (id, w) => `https://images.unsplash.com/photo-${id}?${params}&w=${w}`;

// Modern luxury home exteriors — used for design listings, range tiles,
// collection cards, hero fallback (at higher widths).
const HOME_EXTERIORS = [
  u("1564013799919-ab600027ffc6", 1200),
  u("1600596542815-ffad4c1539a9", 1200),
  u("1613977257363-707ba9348227", 1200),
  u("1568605114967-8130f3a36994", 1200),
  u("1570129477492-45c003edd2be", 1200),
  u("1605276374104-dee2a0ed3cd6", 1200),
  u("1512917774080-9991f1c4c750", 1200),
  u("1582268611958-ebfd161ef9cf", 1200),
  u("1600585154340-be6161a56a0c", 1200),
  u("1597047084897-51e81819a499", 1200),
  u("1499793983690-e29da59ef1c2", 1200),
  u("1502672023488-70e25813eb80", 1200),
  u("1494526585095-c41746248156", 1200),
  u("1480074568708-e7b720bb3f09", 1200),
  u("1448630360428-65456885c650", 1200),
  u("1430285561322-7808604715df", 1200),
  u("1502005229762-cf1b2da7c5d6", 1200),
  u("1583608205776-bfd35f0d9f83", 1200),
  u("1564540583246-934409427776", 1200),
];

// Interior shots for service detail pages and gallery fallbacks.
const HOME_INTERIORS = [
  u("1600607687939-ce8a6c25118c", 1200),
  u("1600210492486-724fe5c67fb0", 1200),
  u("1600585154526-990dced4db0d", 1200),
  u("1600566753190-17f0baa2a6c3", 1200),
  u("1493809842364-78817add7ffb", 1200),
  u("1505691938895-1758d7feb511", 1200),
  u("1518883014066-08a2d7a45f23", 1200),
  u("1416331108676-a22ccb276e35", 1200),
  u("1502005097973-6a7082348e28", 1200),
  u("1505691723518-36a5ac3be353", 1200),
  u("1545324418-cc1a3fa10c00", 1200),
  u("1565182999561-18d7dc61c393", 1200),
  u("1571055107559-3e67626fa8be", 1200),
  u("1588854337115-1c67d9247e4d", 1200),
];

// Front-of-house close-ups for facade tiles.
const FACADES = [
  u("1600047509807-ba8f99d2cdde", 900),
  u("1605276374104-dee2a0ed3cd6", 900),
  u("1582268611958-ebfd161ef9cf", 900),
  u("1564013799919-ab600027ffc6", 900),
  u("1568605114967-8130f3a36994", 900),
  u("1502672023488-70e25813eb80", 900),
  u("1494526585095-c41746248156", 900),
  u("1448630360428-65456885c650", 900),
  u("1480074568708-e7b720bb3f09", 900),
  u("1583608205776-bfd35f0d9f83", 900),
  u("1487958449943-2429e8be8625", 900),
  u("1486325212027-8081e485255e", 900),
];

const DISPLAY_HOMES = [
  u("1568605114967-8130f3a36994", 1200),
  u("1600585154340-be6161a56a0c", 1200),
  u("1613977257363-707ba9348227", 1200),
  u("1605276374104-dee2a0ed3cd6", 1200),
  u("1499793983690-e29da59ef1c2", 1200),
  u("1502005229762-cf1b2da7c5d6", 1200),
  u("1448630360428-65456885c650", 1200),
  u("1564540583246-934409427776", 1200),
  u("1571055107559-3e67626fa8be", 1200),
  u("1502672023488-70e25813eb80", 1200),
];

const HOUSE_LAND = [
  u("1582268611958-ebfd161ef9cf", 1200),
  u("1564013799919-ab600027ffc6", 1200),
  u("1600596542815-ffad4c1539a9", 1200),
  u("1597047084897-51e81819a499", 1200),
  u("1494526585095-c41746248156", 1200),
  u("1480074568708-e7b720bb3f09", 1200),
  u("1430285561322-7808604715df", 1200),
  u("1565182999561-18d7dc61c393", 1200),
  u("1487958449943-2429e8be8625", 1200),
  u("1600573472556-e636c2acda88", 1200),
];

const MATTERPORT = [
  u("1600210492486-724fe5c67fb0", 1200),
  u("1600607687939-ce8a6c25118c", 1200),
  u("1600566753190-17f0baa2a6c3", 1200),
  u("1493809842364-78817add7ffb", 1200),
  u("1505691938895-1758d7feb511", 1200),
  u("1416331108676-a22ccb276e35", 1200),
  u("1505691723518-36a5ac3be353", 1200),
  u("1545324418-cc1a3fa10c00", 1200),
];

const BLOGS = [
  u("1600585154526-990dced4db0d", 1200),
  u("1600585154340-be6161a56a0c", 1200),
  u("1600566753190-17f0baa2a6c3", 1200),
  u("1556909114-f6e7ad7d3136", 1200),
  u("1502005097973-6a7082348e28", 1200),
  u("1542401886-65d6c61db217", 1200),
  u("1510627498534-cf7e9002facc", 1200),
  u("1487958449943-2429e8be8625", 1200),
  u("1416331108676-a22ccb276e35", 1200),
  u("1502672023488-70e25813eb80", 1200),
];

// Hero pool — bright, daylight classic double-storey home exteriors. No
// interiors, no dusk shots. Every URL was HEAD-checked at authoring time.
const HERO = [
  u("1593696954577-ab3d39317b97", 1920),
  u("1572120360610-d971b9d7767c", 1920),
  u("1554995207-c18c203602cb", 1920),
  u("1480074568708-e7b720bb3f09", 1920),
  u("1494526585095-c41746248156", 1920),
  u("1502672023488-70e25813eb80", 1920),
  u("1448630360428-65456885c650", 1920),
  u("1505873242700-f289a29e1e0f", 1920),
];

// Portrait headshots for team members when admin hasn't uploaded a photo.
// Mix of casual professional shots so the grid doesn't feel uniform.
const TEAM = [
  u("1507003211169-0a1dd7228f2d", 600),
  u("1573496359142-b8d87734a5a2", 600),
  u("1494790108377-be9c29b29330", 600),
  u("1438761681033-6461ffad8d80", 600),
  u("1506794778202-cad84cf45f1d", 600),
  u("1517841905240-472988babdf9", 600),
  u("1500648767791-00dcc994a43e", 600),
  u("1487412720507-e7ab37603c6f", 600),
  u("1535713875002-d1d0cf377fde", 600),
  u("1521119989659-a83eee488004", 600),
  u("1539571696357-5a69c17a67c6", 600),
  u("1542909168-82c3e7fdca5c", 600),
];

const POOLS = {
  design: HOME_EXTERIORS,
  interior: HOME_INTERIORS,
  facade: FACADES,
  display: DISPLAY_HOMES,
  houseLand: HOUSE_LAND,
  matterport: MATTERPORT,
  blog: BLOGS,
  hero: HERO,
  team: TEAM,
};

// Used as a last-resort hard fallback when even an Unsplash URL fails.
// Picsum always returns *some* image, so the UI never shows a broken icon.
const HARD_FALLBACK = (key) =>
  `https://picsum.photos/seed/${encodeURIComponent(String(key))}/1200/800`;

/**
 * Deterministic 32-bit FNV-1a hash so the same key always picks the same
 * photo. That keeps cards stable across re-renders.
 */
function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = (h * 16777619) >>> 0;
  }
  return h;
}

export function placeholderImage(pool = "design", key = "default") {
  const list = POOLS[pool] ?? HOME_EXTERIORS;
  return list[hash(String(key)) % list.length];
}

export function imageOrPlaceholder(src, { pool = "design", key = "default" } = {}) {
  if (src) return assetUrl(src);
  return placeholderImage(pool, key);
}

/**
 * `onError` handler for <img> tags. If the primary URL fails, swap to a
 * Picsum fallback so the visitor still sees an image rather than a broken
 * icon. Used by FallbackImg below.
 */
export function imgErrorFallback(key = "default") {
  return (e) => {
    const target = e.currentTarget;
    if (target.dataset.fallbackApplied) return;
    target.dataset.fallbackApplied = "1";
    target.src = HARD_FALLBACK(key);
  };
}